import { render, staticRenderFns } from "./PropertyView.vue?vue&type=template&id=aa71b302&scoped=true"
import script from "./PropertyView.vue?vue&type=script&lang=js"
export * from "./PropertyView.vue?vue&type=script&lang=js"
import style0 from "./PropertyView.vue?vue&type=style&index=0&id=aa71b302&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa71b302",
  null
  
)

export default component.exports